import React from "react"

const Availability = ( { product, type  } ) => {
  let notice = product.getNotice(type)
  return (
    <div className="availability">
      {notice}
    </div>
  )
}


export default Availability


// WEBPACK FOOTER //
// ./src/components/Product/Availability.js